import { useState } from "react";
import { Card, CardBody, Table, TabPane } from "reactstrap";
import { del } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";
import DefaultButton from "../../../../../components/Buttons/Default";
import IconButton from "../../../../../components/Buttons/IconButton";
import { IoCreateOutline } from "react-icons/io5";
import { BsTrash3 } from "react-icons/bs";
import ConfirmationModal from "../../../../../components/Modals/Confirmation";
import CreateCallPurposeModal from "../Modals/CreateCallPurpose";
import { useTranslation } from "react-i18next";

function CallPurposesTab({ callPurposes, refreshSettings }) {
  const { t } = useTranslation();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [purposeToDelete, setPurposeToDelete] = useState(null);
  const [purposeToEdit, setPurposeToEdit] = useState(null);

  const deleteCallPurpose = async () => {
    const data = await del(`/crm/settings/call-purposes/delete/${purposeToDelete}`);
    if(data?.success) {
      refreshSettings();
      setPurposeToDelete(null);
      toast.success(t('crm.settings.call_purposes.deleted'));
    }
  }

  return(
    <TabPane tabId="call-purposes">
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="text-muted small fw-semibold text-uppercase mb-0">
              { t('crm.settings.call_purposes.title') }
            </p>
            <DefaultButton
              color="primary"
              size="sm"
              onClick={() => {
                setPurposeToEdit(null);
                setCreateModalOpen(true);
              }}
            >
              + { t('common.create') }
            </DefaultButton>
          </div>

          <Table hover responsive className="mb-0">
            <thead className="table-light">
              <tr>
                <th>{ t('common.name') }</th>
                <th>{ t('timeline.createdBy') }</th>
                <th>{ t('common.actions') }</th>
              </tr>
            </thead>
            <tbody>
              {callPurposes?.map((data, key) => (
                <tr key={key}>
                  <td>{ data.name }</td>
                  <td>{ data.created_by?.firstname + ' ' + data.created_by?.lastname }</td>
                  <td>
                    <div className="d-flex align-items-center gap-2 h-100">
                      <IconButton
                        size="sm" 
                        outline 
                        color="secondary"
                        onClick={() => {
                          setPurposeToEdit(data);
                          setCreateModalOpen(true);
                        }}
                      >
                        <IoCreateOutline />
                      </IconButton>
                      <IconButton
                        size="sm" 
                        outline 
                        color="danger"
                        onClick={() => setPurposeToDelete(data.id)}
                      >
                        <BsTrash3 />
                      </IconButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <CreateCallPurposeModal 
        isOpen={createModalOpen}
        toggle={() => setCreateModalOpen(false)}
        refreshSettings={refreshSettings}
        purposeToEdit={purposeToEdit}
      />

      <ConfirmationModal
        isOpen={purposeToDelete !== null}
        title={t('crm.settings.call_purposes.deleteTitle')}
        message={t('crm.settings.call_purposes.deleteMessage')}
        onConfirm={deleteCallPurpose}
        toggle={() => setPurposeToDelete(null)}
      />
    </TabPane>
  );
}

export default CallPurposesTab;